import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeftRight } from "lucide-react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from "../ui/dialog";
import { Button } from "../ui/button";
import { useHandoff } from "../../contexts/HandoffContext";

// Accept/Reject prompt for an incoming "Switch" request from another of this
// user's own devices. Rendered once at the app shell level (see AppLayout)
// so it can pop up regardless of which tab is active. Sized to fit a small
// phone screen — tight width cap plus compact padding/type scale on mobile.
const HandoffIncomingDialog = () => {
  const { incomingRequest, respondIncoming } = useHandoff();
  const navigate = useNavigate();
  const [secondsLeft, setSecondsLeft] = useState(0);

  useEffect(() => {
    if (!incomingRequest) return undefined;
    const tick = () => {
      const left = Math.max(0, Math.round((new Date(incomingRequest.expires_at).getTime() - Date.now()) / 1000));
      setSecondsLeft(left);
    };
    tick();
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, [incomingRequest]);

  if (!incomingRequest) return null;

  const handleAccept = async () => {
    const result = await respondIncoming(incomingRequest.id, true);
    if (result) navigate(incomingRequest.path);
  };
  const handleReject = () => respondIncoming(incomingRequest.id, false);

  return (
    <Dialog open onOpenChange={(open) => !open && handleReject()}>
      <DialogContent className="max-w-[280px] sm:max-w-sm w-[85vw] sm:w-full p-3 sm:p-4 gap-1.5 sm:gap-2">
        <DialogHeader className="space-y-0.5">
          <div className="flex items-center gap-1.5 pr-4">
            <ArrowLeftRight className="w-3.5 h-3.5 sm:w-4 sm:h-4 text-primary flex-shrink-0" />
            <DialogTitle className="text-sm sm:text-base">Switch request</DialogTitle>
          </div>
          <DialogDescription className="text-[11px] sm:text-sm break-words whitespace-normal leading-snug">
            {incomingRequest.from_device_label || "Another device"} wants to open this
            page here: <span className="font-mono text-[10px] sm:text-xs break-all">{incomingRequest.path}</span>
          </DialogDescription>
        </DialogHeader>

        <p className="text-[10px] sm:text-xs text-muted-foreground">Expires in {secondsLeft}s</p>

        <DialogFooter className="gap-1.5 sm:gap-2">
          <Button variant="outline" size="sm" className="w-full sm:w-auto" onClick={handleReject}>Reject</Button>
          <Button size="sm" className="w-full sm:w-auto" onClick={handleAccept}>Accept</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default HandoffIncomingDialog;
